export interface ICustomerCreditCheckResponseModel {
  result: string;
  message: string;
}

export class CustomerCreditCheckResponseModel {
  result: string;
  message: string;
}
